import React from "react";
import { NavLink } from "react-router-dom";

const adminNavItems = [
  { to: "/admin/resumes", label: "All Resumes", icon: "R" },
  { to: "/admin/users", label: "Candidates", icon: "C" },
  { to: "/admin/companies", label: "Companies", icon: "C" },
  { to: "/admin/jobs", label: "Job Management", icon: "J" },
];

export default function AdminLayout({ title, description, children }) {
  return (
    <div className="min-h-[calc(100vh-4rem)] bg-slate-50">
      <div className="sticky top-16 z-30 border-b border-gray-200 bg-white">
        <div className="flex items-center justify-between px-4 py-3 sm:px-6">
          <div className="flex items-center gap-3">
            <span className="text-xl text-blue-600">+</span>
            <div className="flex items-center gap-3">
              <h1 className="text-lg font-semibold text-gray-900">Admin Panel</h1>
              <span className="rounded bg-blue-50 px-2 py-0.5 text-xs font-medium text-blue-600">v1.0</span>
            </div>
          </div>
          <NavLink
            to="/dashboard"
            className="rounded-md bg-gray-50 px-3 py-1.5 text-xs text-gray-500 transition-colors hover:bg-gray-100 hover:text-gray-700"
          >
            Back to Dashboard
          </NavLink>
        </div>
      </div>

      <div className="border-b border-gray-200 bg-white">
        <div className="overflow-x-auto px-4 sm:px-6">
          <div className="flex gap-6">
            {adminNavItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                className={({ isActive }) =>
                  `flex items-center gap-1.5 whitespace-nowrap border-b-2 px-1 py-3 text-sm font-medium transition-colors ${
                    isActive
                      ? "border-blue-500 text-blue-600"
                      : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
                  }`
                }
              >
                <span>{item.icon}</span>
                {item.label}
              </NavLink>
            ))}
          </div>
        </div>
      </div>

      <div className="px-4 py-8">
        <div className="w-full">
          <div className="mb-4 rounded-lg border border-gray-200 bg-white px-4 py-4 shadow-sm">
            <h2 className="text-2xl font-bold text-slate-900">{title}</h2>
            {description ? (
              <p className="mt-2 text-sm text-slate-600">{description}</p>
            ) : null}
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
